import { Container, Text } from '@mantine/core';

export const Playground = () => {
  return (
    <Container>
      <Text>Playground</Text>
    </Container>
  );
};
